var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'custom-header-footer': _vm.$config.customHeaderAndFooter
  },attrs:{"id":"app"}},[(_vm.$config.customHeaderAndFooter)?_c('ogs-header'):_vm._e(),_c('LocaleChanger'),_c('router-view',{attrs:{"id":"page"}}),_c('ConfirmationModal'),(_vm.$config.customHeaderAndFooter)?_c('ogs-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }